import { errorView } from "../../../../helpers/ErrorHandler";
import { ChemicalTransportRouteFormValues, Transportation } from "./chemicalTransport.types";

export const validateChemicalRoute = (
  routeData: ChemicalTransportRouteFormValues,
  chemicalId?: string
): boolean => {
  if (!chemicalId) {
    errorView("Chemical ID is missing");
    return false;
  }
  if (!routeData.transportationType) {
    errorView("Please select a transportation type");
    return false;
  }
  const distance = parseFloat(routeData.distance);
  if (!distance || distance <= 0) {
    errorView("Distance must be greater than 0");
    return false;
  }
  return true;
};

export const toRouteFormValues = (route: Transportation): ChemicalTransportRouteFormValues => ({
  transportationType: (route.transportType ?? route.transportationType ?? "").toString(),
  distance: route.distance?.toString() ?? ""
});
